import styled from 'styled-components'

export const Title = styled.h3`
  font-size: 20px;
  letter-spacing: 0.96px;
  font-weight: 400;
  color: #222;
  width: 100%;
  text-align: center;
  margin-bottom: 25px;
`

export const Row = styled.div`
  width: 100%;
  position: relative;
  margin-bottom: 30px;
  &.flex {
    display: flex;
    > div:first-child {
      margin-right: 10px;
    }
    &.flex-wrap {
      flex-wrap: wrap;
    }
  }

  .solicitation-time-picker {
    width: 100%;
    height: 56px;
    line-height: 40px;
    text-align: left;
    padding: 0px 15px;
    border: 1px solid #999999;
    border-radius: 8px;
    -moz-border-radius: 8px;
    -webkit-border-radius: 8px;
    color: #555555;
    font-size: 16px;
    font-weight: 400;
    background-color: #fff;
    display: block;
  }

  .react-datepicker-popper {
    z-index: 2;
    width: 100%;

    div,
    .react-datepicker__time-box {
      width: 100%;
    }
  }

  &.otherJustifacation {
    textarea {
      margin-bottom: -10px;
    }
  }

  .errorChoice,
  .errorOtherJustifacation {
    flex: 1 0 100%;
    span {
      color: #ff0000;
      font-size: 13px;
      font-family: 'Open Sans';
      font-weight: 400;
      margin: 0px;
    }
  }
`
